import { styled } from 'styled-components';
import useWagerStats from '@src/hooks/useWagerStats';

const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  /* align-items: center; */
  margin-top: 10px;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`;

const StatItem = styled.span<{ color: string }>`
  color: ${(props) => props.color};
  font-size: 30px;
  margin-right: 20px;
`;

export default function Stats() {
  const stats = useWagerStats();

  return (
    <StatsContainer>
      <StatItem color='blue'>plays: {stats.plays}</StatItem>
      <StatItem color='black'>W/L: {stats.winLossRatio}</StatItem>
    </StatsContainer>
  );
}
// <StatItem color='green'>wins: {stats.wins}</StatItem>
// <StatItem color='red'>losses: {stats.losses}</StatItem>
// <StatItem color='black'>wagered: {stats.wagered}</StatItem>
// <StatItem color='green'>won: {stats.won}</StatItem>
// <StatItem color={stats.profit < 0 ? 'red' : 'green'}>
//   profit: {stats.profit}
// </StatItem>
